/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when the price toggle is clicked
 *
 * &nbsp;
 */
export class PriceToggleClick extends AnalyticsEvent {
  eventName = 'price-toggle-click';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.marketing.promos;

  constructor(eventProperties: {
    partner: string;
    source: string;
    personId: string;
    newState: string;
  }) {
    super(eventProperties);
  }
}
